#import "../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachSupplierDocument($input: AttachSupplierDocumentInput!) {
  attachSupplierDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
